import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";
import { getSelectedCompanyIds, resolveSnapshotProjectId } from "../utils/primaryProjectId";

function resolveClientGroupProjectIds(group) {
  const fromPayload = Array.isArray(group?.ids_projetos)
    ? group.ids_projetos.map((x) => Number(x)).filter((n) => Number.isFinite(n) && n > 0)
    : [];
  if (fromPayload.length) return fromPayload;
  const selected = getSelectedCompanyIds();
  if (selected.length) return selected;
  const fallback = resolveSnapshotProjectId(group?.id_projeto ?? null);
  return fallback ? [fallback] : [];
}

export const useClientGroups = (page = 1, limit = 100, search = "") => {
  const queryClient = useQueryClient();

  const query = useQuery(
    ["clientGroups", page, limit, search],
    () => fetchData(`/clients-groups?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`),
    {
      staleTime: 5000,
      refetchOnWindowFocus: false,
      select: (response) => ({
        groups: response?.data || [],                 // lista plana com {id, nome, id_pai, ordem, excluido, ...}
        pagination: response?.pagination || { total: 0 },
      }),
    }
  );

  const updateMutation = useMutation(
    (group) => {
      const method = group?.id ? "PUT" : "POST";
      const endpoint = group?.id ? `/clients-groups/${group.id}` : `/clients-groups`;
      if (method !== "POST") return fetchData(endpoint, method, group);
      const payload = { ...group };
      if (!Array.isArray(payload.ids_projetos) || !payload.ids_projetos.length) {
        const ids = resolveClientGroupProjectIds(group);
        if (ids.length) payload.ids_projetos = ids;
      }
      return fetchData(endpoint, method, payload);
    },
    { onSuccess: () => queryClient.invalidateQueries("clientGroups") }
  );

  const deleteMutation = useMutation(
    (id) => fetchData(`/clients-groups/${id}`, "DELETE"),
    { onSuccess: () => queryClient.invalidateQueries("clientGroups") }
  );

  return { ...query, updateMutation, deleteMutation };
};
